import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CounterSection from '../../sections/CounterSection/CounterSection';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';
import { GlobalStyle } from '../../global/global';
import CarouselSectionWithImages from '../../sections/CarouselSecitionWithImages/CarouselSectionWithImages';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import LogotypeBar from '../../sections/LogotypeBar/LogotypeBar';
import StyledButton from '../../components/Button/Button';

import {
    Box,
    Flex,
    Text,
    Image,
    Heading,
    Hide,
    Show,
    List,
    ListItem,
    Link,
} from '@chakra-ui/react';
import TabsSection from '../../sections/TabsSection/TabsSection';
import SubscriptionSection from '../../sections/SubscriptionSection/SubscriptionSection';
import PromoBar from '../../sections/PromoBar/PromoBar';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import { StyledHeading, StyledHighlight } from '../../sections/CalltoActionSection/styles';
import FormSection from '../../sections/FormSection/FormSection';
import React, { useEffect } from 'react';
interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=615043&ext=.webp',
    alt: 'Zdjęcie marketing automation',
};

export default function MarketingAutomationComponent(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Automatyzacja marketingu w sklepie internetowym"
                subTitle={
                    'Oszczędzaj czas i sprzedawaj więcej – włącz automatyzację marketingu w swoim sklepie internetowym.'
                }
                image={image}
                buttons={[
                    {
                        title: 'Dowiedz się więcej',
                        href: 'https://www.idosell.com/pl/baza-wiedzy/zwiekszanie-sprzedazy-w-sklepie-internetowym/personalizowane-wiadomosci-do-twoich-klientow/automatyzacja-marketingu-wiadomosci-triggerowane/',
                        variant: 'default',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: 'calc(100% + 8rem)',
                            top: '-4rem',
                            width: '100vw',
                            left: '-50vw',
                            marginLeft: '50%',
                            zIndex: -2,
                            backgroundColor: 'rgba(238, 238, 238, 1)',
                        },
                        md: {
                            height: 'calc(100% + 10rem) !important',
                            top: '-5rem !important',
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <Box
                        display={'flex'}
                        flexDirection={'column'}
                        gap={'50px'}
                        position={'relative'}
                    >
                        <Box>
                            <Box
                                display={'flex'}
                                gap={'30px'}
                                alignItems={'center'}
                                flexDir={{ base: 'column', lg: 'row' }}
                            >
                                <Box width={{ base: '100%', lg: '50%' }}>
                                    <Show above="lg">
                                        <Image
                                            src="https://www.idosell.com/panel/file-gate.php?id=615042&ext=.png"
                                            alt=""
                                        ></Image>
                                    </Show>
                                    <Show below="lg">
                                        <Image
                                            src="https://www.idosell.com/panel/file-gate.php?id=615045&ext=.png"
                                            alt=""
                                        ></Image>
                                    </Show>
                                </Box>
                                <Box width={{ base: '100%', lg: '50%' }} padding={'30ox'}>
                                    <Text
                                        fontSize={'34px'}
                                        lineHeight={'1.5'}
                                        fontWeight={'600'}
                                        color={'#1AAC7A'}
                                        mb="30px"
                                    >
                                        Marketing automation w e&#8209;commerce - poznaj
                                        najważniejsze korzyści:
                                    </Text>
                                    <List
                                        spacing={'15px'}
                                        fontSize={'18px'}
                                        lineHeight={'27px'}
                                        color={'#171717'}
                                    >
                                        <ListItem display={'flex'}>
                                            <Box mr={'30px'} mt={'5px'}>
                                                <svg
                                                    width="20"
                                                    height="25"
                                                    viewBox="0 0 20 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </svg>
                                            </Box>

                                            <Box flex={'1'}>
                                                <Text
                                                    color={''}
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    mb="5px"
                                                >
                                                    Lepsze relacje z klientami
                                                </Text>
                                                <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                    Automatyzacja marketingu pozwala skuteczniej
                                                    zarządzać komunikacją i budować trwałe relacje z
                                                    klientami.
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <Box mr={'30px'} mt={'5px'}>
                                                <svg
                                                    width="20"
                                                    height="25"
                                                    viewBox="0 0 20 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </svg>
                                            </Box>

                                            <Box flex={'1'}>
                                                <Text
                                                    color={''}
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    mb="5px"
                                                >
                                                    Większa sprzedaż i konwersja
                                                </Text>
                                                <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                    Docieraj do klientów we właściwym momencie i
                                                    dostosuj komunikaty do ich potrzeb. Dzięki temu
                                                    skuteczniej przeprowadzisz ich przez ścieżkę
                                                    zakupową.
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <Box mr={'30px'} mt={'5px'}>
                                                <svg
                                                    width="20"
                                                    height="25"
                                                    viewBox="0 0 20 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </svg>
                                            </Box>

                                            <Box flex={'1'}>
                                                <Text
                                                    color={''}
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    mb="5px"
                                                >
                                                    Przewidywalne koszty
                                                </Text>
                                                <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                    W IdoSell opłaty nie są zależne od liczby
                                                    klientów – zamiast tego oferujemy stałą,
                                                    niewielką miesięczną opłatę, niezależnie od
                                                    wielkości Twojego biznesu.
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <Box mr={'30px'} mt={'5px'}>
                                                <svg
                                                    width="20"
                                                    height="25"
                                                    viewBox="0 0 20 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </svg>
                                            </Box>

                                            <Box flex={'1'}>
                                                <Text
                                                    color={''}
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    mb="5px"
                                                >
                                                    Automatyzacja procesów
                                                </Text>
                                                <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                    Korzystaj z zaawansowanych technik bez
                                                    dodatkowych inwestycji. Dodatkowo otrzymasz
                                                    wsparcie specjalistów.
                                                </Text>
                                            </Box>
                                        </ListItem>
                                        <ListItem display={'flex'}>
                                            <Box mr={'30px'} mt={'5px'}>
                                                <svg
                                                    width="20"
                                                    height="25"
                                                    viewBox="0 0 20 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </svg>
                                            </Box>
                                            <Box flex={'1'}>
                                                <Text
                                                    fontSize={'21px'}
                                                    lineHeight={'1.5'}
                                                    fontWeight={'600'}
                                                    mb="5px"
                                                >
                                                    Oszczędność czasu
                                                </Text>
                                                <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                    Automatyzacja powtarzalnych działań
                                                    marketingowych pozwoli Ci oszczędzić czas i
                                                    zasoby.
                                                </Text>
                                            </Box>
                                        </ListItem>
                                    </List>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box
                    p={{ base: '50px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column-reverse', lg: 'row' }}
                        >
                            <Box
                                display={'flex'}
                                justifyContent={'start'}
                                alignItems={'start'}
                                flexDir={'column'}
                                width={{ base: '100%', lg: '50%' }}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Marketing Automation w IdoSell
                                </Text>
                                <Text
                                    color={'#171717'}
                                    fontWeight={'700'}
                                    fontSize={'18px'}
                                    marginBottom={'15px'}
                                >
                                    Automatyzacja marketingu pozwala na budowanie lepszych relacji z
                                    klientami i zwiększanie konwersji.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'30px'}>
                                    Wbudowane narzędzie do automatyzacji marketingu w IdoSell
                                    umożliwia wysyłkę SMS&#8209;ów i e&#8209;maili na podstawie
                                    określonych zdarzeń. Dla każdego z nich można tworzyć dowolną
                                    liczbę kampanii, planując wysyłkę przed lub po danym zdarzeniu.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'45px'}>
                                    System sprawdza się w wielu zastosowaniach, m.in. w pozyskiwaniu
                                    opinii, nagradzaniu aktywnych klientów czy prowadzeniu
                                    cyklicznych poradników.
                                </Text>
                                <Link
                                    href="https://pomoc.idosell.com/marketing-i-promocje/narzedzia-marketingowe/automatyzacja-marketingu/"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Włącz Marketing Automation
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                            <Box
                                justifyContent={'center'}
                                alignItems={'center'}
                                width={{ base: '100%', lg: '50%' }}
                                display={'flex'}
                            >
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=615041&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=615044&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box p={{ base: '50px 0', lg: '50px 0 112.5px 0' }}>
                    <Heading
                        as="h2"
                        fontWeight={600}
                        fontSize={{ base: '25px', lg: '34px' }}
                        lineHeight={{ base: '37px', lg: '48px' }}
                        textAlign={'center'}
                        marginBottom={{ base: '5px', lg: '20px' }}
                    >
                        {'Partnerzy Marketing Automation w IdoSell'}
                    </Heading>
                    <Text
                        fontSize={{ base: '16px', lg: '18px' }}
                        marginBottom={{ base: '35px', lg: '50px' }}
                        textAlign={'center'}
                    >
                        W IdoSell zapewniamy nie tylko wbudowane mechanizmy Marketing Automation.
                        Możesz skorzystać z integrację z zaawansowanych rozwiązań naszych partnerów
                        – Revhuner oraz Salesmenago.
                    </Text>
                    <Flex
                        flexDirection={{ base: 'column', md: 'row' }}
                        gap={{ base: '15px', lg: '30px' }}
                    >
                        <Flex
                            aspectRatio={1}
                            padding={{ base: '35px 20px', xl: '95px 50px' }}
                            background={'#E3E3E3'}
                            flexGrow={1}
                            flexDirection={'column'}
                            flexBasis={{ md: 0.5 }}
                        >
                            <Image
                                maxW={'240px'}
                                marginBottom={'15px'}
                                src="https://www.idosell.com/panel/file-gate.php?id=615039&ext=.png"
                                alt=""
                            ></Image>
                            <Text
                                as="strong"
                                fontSize={{ base: '46px', xl: '51px' }}
                                marginBottom={'15px'}
                                color={'#171717'}
                            >
                                Revhunter
                            </Text>
                            <Text marginBottom={'15px'}>
                                Pozyskaj nowych klientów i zamień ich w kupujących z Revhunter.
                                Narzędzie sprowadza do Twojego sklepu użytkowników zainteresowanych
                                ofertą i angażuje ich na każdym etapie customer journey – aż do
                                konwersji. Dzięki dynamicznym kampaniom e-mail i display rekomenduje
                                bestsellery oraz skutecznie odzyskuje porzucone koszyki.
                            </Text>
                            <Box>
                                <StyledButton
                                    href={
                                        'https://pomoc.idosell.com/marketing-i-promocje/narzedzia-marketingowe/revhunter '
                                    }
                                    style={'default'}
                                    target="_self"
                                >
                                    Włącz Revhunter
                                </StyledButton>
                            </Box>
                        </Flex>
                        <Flex
                            aspectRatio={1}
                            padding={{ base: '35px 20px', xl: '95px 50px' }}
                            background={'#E3E3E3'}
                            flexGrow={1}
                            flexDirection={'column'}
                            flexBasis={{ md: 0.5 }}
                        >
                            <Image
                                maxW={'240px'}
                                marginBottom={'15px'}
                                src="https://www.idosell.com/panel/file-gate.php?id=615040&ext=.png"
                                alt=""
                            ></Image>
                            <Text
                                as="strong"
                                fontSize={{ base: '46px', xl: '51px' }}
                                marginBottom={'15px'}
                                color={'#171717'}
                            >
                                SALESmanago
                            </Text>
                            <Text marginBottom={'15px'}>
                                SALESmanago to system automatyzacji marketingu dostosowany zarówno
                                do początkujących, jak i doświadczonych sprzedawców. Oferuje
                                zaawansowane narzędzia do analizy ruchu i personalizowanych działań
                                marketingowych opartych na aktywności potencjalnych oraz obecnych
                                klientów.
                            </Text>
                            <Box>
                                <StyledButton
                                    href={
                                        'https://pomoc.idosell.com/marketing-i-promocje/narzedzia-marketingowe/salesmanago'
                                    }
                                    style={'default'}
                                    target="_self"
                                >
                                    Włącz SALESmanago
                                </StyledButton>
                            </Box>
                        </Flex>
                    </Flex>
                </Box>
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box
                                justifyContent={'center'}
                                alignItems={'center'}
                                width={{ base: '100%', lg: '50%' }}
                                display={'flex'}
                            >
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=615038&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=615046&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                justifyContent={'start'}
                                alignItems={'start'}
                                flexDir={'column'}
                                width={{ base: '100%', lg: '50%' }}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Rekomendacje, które sprzedają
                                </Text>
                                <Text
                                    color={'#171717'}
                                    fontWeight={'700'}
                                    fontSize={'18px'}
                                    marginBottom={'15px'}
                                >
                                    IdoSell RS to zaawansowany system rekomendacji produktowych,
                                    który personalizuje ofertę w Twoim sklepie internetowym.
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'45px'}>
                                    IdoSell RS rozszerza możliwości Marketing Automation, m.in.
                                    poprzez wysyłanie rekomendacji po porzuceniu koszyka.
                                    Spersonalizowane sugestie produktowe pomagają zwiększyć
                                    sprzedaż, skracając czas potrzebny klientowi na znalezienie
                                    poszukiwanego produktu.
                                </Text>
                                <Link
                                    href="https://www.idosell.com/pl/dashboard/?ref=http%3A%2F%2Fwww.idosell.com%2Foauth%2Fauthorize%2F%3Fresponse_type%3Dcode%26client_id%3Dcsc_shop%26redirect_uri%3Dhttps%3A%2F%2Fcsc.idosell.com%2Fapi%2F%26scope%3Dopenid%2520csc%26state%3DLGEdgGNL3-6CqpwJHN06X0F1EbKVQZUHoKiG_zVeQqKpxzPwqIzZPdga9B2wibhszH8-"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Włącz IdoSell RS
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <ContactSection pb={1} mb={14} />
            </div>
        </ThemeProvider>
    );
}
